export const normalizeBusinessTypes = (types = []) => {
	if (!Array.isArray(types)) return []

	return [
		...new Set(
			types.map((type) => String(type ?? '').trim()).filter(Boolean)
		),
	]
}

export const getVendorBusinessTypes = (vendor) =>
	normalizeBusinessTypes([
		...(Array.isArray(vendor?.businessTypes) ? vendor.businessTypes : []),
		vendor?.customBusinessType,
	])
